import { Typography } from '@mui/material';
import { withResourceProtection } from 'app/components/ReusableUIComponents/HOCs/ResourceProtected/withResourceProtection';
import type { MetricRegistryMeta } from '../types';
import { getMetricInfoFields } from '../utils/tileMeta';
import { CATALOG_ID_RESOURCE } from '../utils/viewConfig';

type Props = {
  registry?: MetricRegistryMeta | null;
};

function CatalogIdBadgeBase({ registry }: Props) {
  const { catalogId } = getMetricInfoFields(registry);
  if (!catalogId) return null;

  return (
    <Typography
      variant="caption"
      sx={{
        position: 'absolute',
        bottom: 8,
        right: 12,
        zIndex: 2,
        color: 'text.secondary',
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: 0.2,
        pointerEvents: 'none',
        userSelect: 'none',
      }}
      aria-label={`Catalog ID ${catalogId}`}
    >
      {catalogId}
    </Typography>
  );
}

/** RBAC `CatalogId`: bottom-right catalog id on metric/insight tiles. */
const CatalogIdBadge = withResourceProtection(CatalogIdBadgeBase, CATALOG_ID_RESOURCE, null);

export default CatalogIdBadge;
